module.exports = __webpack_public_path__ + "static/img/genkin_app.c8251b7e.svg";